<div style="text-align: center; vertical-align: middle;">
  <br><br>
  <h4>Total assets</h4>
  <br>
  <span class="total">$ {{ total }}</span>
  <br><br><br>
</div>

<br>
<mat-divider></mat-divider>
<br>

<h4 class="text-left">Currency breakdown</h4>
<div style="text-align: center; vertical-align: middle;">
  <div class="progress progress-sm r m-v-sm">
    <div *ngFor="let data of currencyBreakdown" class="progress-bar progress-bar-striped {{ currencyColor[data.currency.alias] }}" [ngStyle]="{width: data.pct+'%'}">{{ data.currency.alias }}</div>
  </div>
</div>
